var _classCallCheck = require("/Users/tamir/work/websites/markidim/markidim_web/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/tamir/work/websites/markidim/markidim_web/node_modules/@babel/runtime/helpers/createClass");

var Config = window.Config = require('../../../../config');

var Rx = require('rx');

var CLApi = window.CLApi = require('../cl-api');

var ANALYTICS_BASE_URL = "http://" + Config.AVAILABLE_ENVIRONMENTS[Config.SELECTED_ENV] + "/index.php/analytics";
var POST = 'POST';
var GET = 'GET';

var CLAnalytics =
/*#__PURE__*/
function () {
  "use strict";

  function CLAnalytics(props) {
    _classCallCheck(this, CLAnalytics);

    this.api = new CLApi();
    this.integrations = Config.INTEGRATIONS; //new Integrations(props)
    // loading segment.io if this is web

    if (Config.PLATFORM == "reactjs") {
      // if (!window.analytics) {
      //     !function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on"];analytics.factory=function(t){return function(){var e=Array.prototype.slice.call(arguments);e.unshift(t);analytics.push(e);return analytics}};for(var t=0;t<analytics.methods.length;t++){var e=analytics.methods[t];analytics[e]=analytics.factory(e)}analytics.load=function(t){var e=document.createElement("script");e.type="text/javascript";e.async=!0;e.src=("https:"===document.location.protocol?"https://":"http://")+"cdn.segment.com/analytics.js/v1/"+t+"/analytics.min.js";var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(e,n)};analytics.SNIPPET_VERSION="4.0.0";
      //         //analytics.load("vqnef7y8sm");
      //         analytics.load(Config.SEGMENTIO.key);
      //     }}();
      // }
      var campaign = props && props.location && props.location.query && props.location.query.c ? props.location.query.c : false;

      if (campaign) {
        this.api._request("/set_campaign", POST, {
          campaign: campaign
        }, false, false, ANALYTICS_BASE_URL).subscribe();
      }
    }

    if (Config.PLATFORM == "react-native") {// check for Google-Analytics and Mixpanel keys in config, initialize trackers if those exist
    }

    if (props && props.store) {
      this.deviceInfo = props.store.getState().device;
    }
  }

  _createClass(CLAnalytics, [{
    key: "setDeviceInfo",
    value: function setDeviceInfo(deviceInfo) {
      this.deviceInfo = deviceInfo;
    }
  }, {
    key: "_addCommonParams",
    value: function _addCommonParams(params) {
      if (!params.params) {
        params.params = {};
      }

      if (typeof window !== "undefined") {
        if (window.navigator) {
          var browserParams = ["appName", "appCodeName", "version", "userAgent", "vendor", "platform", "language", "cookieEnabled"];
          params.params.browser = {};
          browserParams.forEach(function (p) {
            params.params.browser[p] = window.navigator[p];
          });
        }

        if (window.screen) {
          var screenParams = ["width", "height", "pixelDepth", "colorDepth"];
          params.params.screen = {};
          screenParams.forEach(function (p) {
            params.params.screen[p] = window.screen[p];
          });

          if (window.screen.orientation) {
            params.params.screen.orientation = {};
            params.params.screen.orientation.angle = window.screen.orientation.angle;
            params.params.screen.orientation.type = window.screen.orientation.type;
          }
        }
      }

      if (this.deviceInfo) {
        params.params.device = this.deviceInfo;
      }

      params.params.environment = Config.SELECTED_ENV;
      return params;
    }
  }, {
    key: "_analyticsRequest",
    value: function _analyticsRequest(url, params) {
      this.api._request(url, POST, this._addCommonParams(params), false, false, ANALYTICS_BASE_URL).subscribe();
    }
  }, {
    key: "page",
    value: function page(pageName) {
      console.log("%ccl-analytics - new page", 'background: green; color: white', pageName); // if (window.analytics) window.analytics.page(pageName);

      this._analyticsRequest("/page", {
        page_name: pageName
      });

      this.integrations.page(pageName);
    }
  }, {
    key: "identify",
    value: function identify(id, params) {
      console.log("device info analytics", this.deviceInfo);
      console.log("%ccl-analytics - identify", 'background: green; color: white', id, params); // if (window.analytics) window.analytics.identify(id,params);

      this.api._request("/identify", POST, {
        id: id,
        params: params
      }, false, false, ANALYTICS_BASE_URL).subscribe();

      this.integrations.identify(id, params); // see comment inside for allowed mixpanel params
    }
  }, {
    key: "track",
    value: function track(event, params) {
      console.log("%ccl-analytics - track", 'background: green; color: white', event, params); // if (window.analytics) window.analytics.track(event,params);

      this._analyticsRequest("/track", {
        name: event,
        params: params
      });

      this.integrations.track(event, params);
    }
  }, {
    key: "trackLink",
    value: function trackLink(link, event, params) {
      console.log("%ccl-analytics - track link", 'background: green; color: white', link, event, params); // if (window.analytics) window.analytics.trackLink(link,event,params);

      params.link = link;

      this._analyticsRequest("/track", {
        name: event,
        params: params
      });
    }
  }]);

  return CLAnalytics;
}();

module.exports = CLAnalytics;